import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import * as React from "react";
import { formatDecimalAsPercent } from "../../util/text_formatting";
import { Container, VerticalContainer } from "./styles";
import { theme } from "../../../globalStyles";
import { dbToVal } from "../LaneVolumeSlider";

export function VolumeSlider({
  onChange,
  onAfterChange,
  currentVolume,
  volumeIndicators = { currentPeak: 0, recentPeak: 0 },
  vertical = false
}) {
  const sliderVal = dbToVal(currentVolume);

  const THICKNESS = 20;

  if (vertical) {
    const VERT_HEIGHT = 110;
    return (
      <div
        style={{
          width: THICKNESS,
          height: VERT_HEIGHT,
          position: "relative"
        }}
      >
        <VerticalContainer>
          <div
            className="volume-level"
            style={{
              height: formatDecimalAsPercent(volumeIndicators.currentPeak)
            }}
          />
          <div
            className="volume-max"
            style={{
              height: formatDecimalAsPercent(volumeIndicators.recentPeak)
            }}
          />
        </VerticalContainer>
        <Slider
          vertical
          min={0}
          max={100}
          defaultValue={sliderVal * 100}
          onAfterChange={onAfterChange}
          onChange={onChange}
          railStyle={{
            width: THICKNESS,
            marginLeft: -5,
            opacity: 0
          }}
          trackStyle={{
            width: THICKNESS,
            marginLeft: -5,
            opacity: 0
          }}
          handleStyle={{
            height: THICKNESS,
            width: THICKNESS,
            backgroundColor: theme.editor.textMedium
          }}
        />
      </div>
    );
  }

  const HEIGHT = THICKNESS;
  const WIDTH = HEIGHT;
  return (
    <div
      style={{
        height: HEIGHT,
        position: "relative",
        width: 120
      }}
    >
      <Container>
        <div
          className="volume-level"
          style={{
            width: formatDecimalAsPercent(volumeIndicators.currentPeak)
          }}
        />
        <div
          className="volume-max"
          style={{
            width: formatDecimalAsPercent(volumeIndicators.recentPeak)
          }}
        />
      </Container>
      <Slider
        min={0}
        max={100}
        defaultValue={sliderVal * 100}
        onAfterChange={onAfterChange}
        onChange={onChange}
        railStyle={{
          height: HEIGHT,
          marginTop: -5,
          opacity: 0
        }}
        trackStyle={{
          height: HEIGHT,
          marginTop: -5,
          opacity: 0
        }}
        handleStyle={{
          height: HEIGHT,
          width: WIDTH,
          backgroundColor: theme.editor.textMedium
        }}
      />
    </div>
  );
}
